import { TaskFlow } from '../types/flow.js';

/**
 * Utility for mapping between Supabase Database rows and Frontend TaskFlow objects.
 * Centralizing this ensures that schema changes only need to be updated in one place.
 */

// Explicit allowlist of columns the client is allowed to read from `task_flows` (SEC-M7).
// Keep in sync with `dbRowToFlow` below — adding a field to the mapper means adding it here too.
// Note: `from_state_id` was dropped from `task_flows` in May 2026.
// Do NOT add it back here without re-adding the column.
export const FLOW_COLUMNS = 'id, team_id, name, description, is_active, current_step, success_state_id, created_at';

export const dbRowToFlow = (row: any): TaskFlow => ({
  id: row.id,
  teamId: row.team_id,
  name: row.name,
  description: row.description || undefined,
  isActive: row.is_active,
  currentStep: row.current_step,
  fromStateId: row.from_state_id ?? null,
  successStateId: row.success_state_id,
  createdAt: new Date(row.created_at),
});

export const mapFlowToDb = (updates: Partial<TaskFlow>): any => {
  const dbUpdates: any = {};
  
  if ('teamId' in updates) dbUpdates.team_id = updates.teamId;
  if ('name' in updates && updates.name !== undefined) dbUpdates.name = updates.name.trim();
  if ('description' in updates) dbUpdates.description = updates.description?.trim() || null;
  if ('isActive' in updates) dbUpdates.is_active = updates.isActive;
  if ('currentStep' in updates) dbUpdates.current_step = updates.currentStep;
  // from_state_id column dropped — silently ignore writes for backwards compat.
  if ('successStateId' in updates) dbUpdates.success_state_id = updates.successStateId;
  
  return dbUpdates;
};
